import React from 'react'
import Layout from "../components/utils/layout";
import Filters from "./filters";
import NamedQueryModule from "../components/data_modules/named_query_module";
import Formatters from "../components/utils/formatters";

const Subscriptions = () => {
    const screenId="Subscriptions"
    const formatters = Formatters()
    const charts = {
        subscriptions_cancelled_multiple : {},
        subscriptions_cancelled_report : {},
        subscriptions_cancelled_details : {
            specialFormatters : {
                child_age_at_cancel: formatters.int,
                parent_account_age: formatters.int
            }
        },
        account_cancellation_within_6_months : {}
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default Subscriptions